/**
 * CustomStreamsCtrl controller
 * List of Custom Streams
 */

// controller mixins
CustomStreamsCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * CustomStreamsCtrl controller
 *
 * @class CustomStreamsCtrl
 * @memberof mwApp/subscribers
 * @see mwApp/subscribers
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 * @mixes mwApp/common.mixin:tabsCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/subscribers.controller:CustomStreamsCtrl
 */
/* @ngInject */
export default function CustomStreamsCtrl ($uibModal, Entity, Extension, Channel, Subscriber, authSvc, alertLiteSvc, subscr, extra) {
  const vm = this
  vm.mixes = [['tabsCtrlMixin', 'tv', 'vod']]
  vm.subscr = subscr
  Subscriber.load({
    id: subscr.id,
    params: { withCustomStreams: true }
  }).then((data) => {
    vm.subscr = data
  }).catch(err => {
    alertLiteSvc.alertError(err)
  })

  /**
   * Extra
   *
   * @memberof mwApp/subscribers.controller:CustomStreamsCtrl
   * @type {Object}
   */
  vm.extra = extra

  /**
   * Assign streams to a subscriber
   *
   * @memberof mwApp/subscribers.controller:CustomStreamsCtrl
   * @function
   * @param subscr
   * @param {String} streamType
   * @param {String} streamItem
   */
  vm.assignStreams = function (subscr, streamType, streamItem) {
    $uibModal.open({
      templateUrl: 'components/subscribers/views/assignStreams.html',
      controller: 'AssignStreamsCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        Subscriber: function () {
          return { ...subscr, streamType, streamItem }
        }
      }
    }).result
      .then(() => {
        vm.getSubscriber()
      })
  }

  vm.getSubscriber = function () {
    Subscriber.load({
      id: subscr.id,
      params: { withCustomStreams: true }
    })
      .then(
        (subscr) => {
          vm.subscr = subscr
        }
      )
  }

  vm.hasFlag = function (flag) {
    return authSvc.hasEnabledFlag(flag)
  }
}
